<template>
  <div class="club-videos">
    <span id="n-view">
      <ClubVideosView
        v-if="showView"
        :sendData="sendData"
        @close="closeView"
      />
    </span>
    <va-card :title="$t('club-videos.cards.title')">
      <va-data-table
        :fields="fields"
        :data="club_videos"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('club-videos.forms.download')}`" placement="bottom">
            <va-button
              flat
              color="green"
              icon="fa fa-download"
              @click="downloadFile($store.getters['environment/cdn'] + '/club-video/' + props.rowData.file, props.rowData.file)"
            />
          </va-popover>
          <va-popover :message="`${$t('club-videos.tooltips.view')}`" placement="bottom">
            <va-button
              flat
              color="red"
              href="#n-view"
              icon="fa fa-video-camera"
              @click="view(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('club-videos.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deletingUpload"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ClubVideosView from './ClubVideosView'

const perPage = 10
export default {
  name: 'club-videos',
  components: {
    ClubVideosView,
  },
  methods: {
    view (data) {
      this.sendData = data
      this.showView = true
    },
    closeView (v) {
      this.showView = v
      this.sendData = null
      this.$apollo.queries.club_videos.refetch()
      this.$apollo.queries.pages.refetch()
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.club_videos.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    downloadFile (url) {
      window.open(url, '_blank')
    },
    deletingUpload () {
      const self = this
      this.$axios.delete(
        '/api/upload',
        {
          data: {
            file: this.deleteId.file,
            path: 'club-video',
          },
        },
      ).then(resp => {
        self.deleting()
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_club_video_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      club_videos: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      userId: null,
      sendData: null,
      showView: false,
    }
  },
  apollo: {
    club_videos: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2) {
        club_videos: club_video(limit: $perPage, offset: $page, order_by: {id: desc}) {
          id
          created_at
          file
          client {
            id
            fullName
          }
          club_video_type {
            type
          }
        }
      }
      `,
      variables: {
        perPage,
        page: 0,
      },
    },
    pages: gql`
    query MyQuery {
      pages: club_video_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'created_at',
        title: this.$t('club-videos.headings.created_at'),
        width: '15%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: 'club_video_type',
        title: this.$t('club-videos.headings.type'),
        width: '30%',
        callback (value) {
          return value.type
        },
      },
      {
        name: 'client',
        title: this.$t('club-videos.headings.client'),
        width: '30%',
        callback (value) {
          return `${value.id} - ${value.fullName}`
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('club_videos')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.club_videos.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
